import React from "react"
import "./index.scss"
import NoDataIcon from "../../../assets/svg/no-data-icon.svg"

const EmptyDataContainer = () => (
  <div className="no-results-wrapper">
    <div className="no-results-content">
      <img src={NoDataIcon} alt="No results" className="no-results-icon" />
      <div className="no-results-text">No data available.</div>
    </div>
  </div>
)

export default EmptyDataContainer
